module.exports = __webpack_public_path__ + "static/img/14.71ea383.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/14.png
// module id = jTvf
// module chunks = 0